export default {
  nav: {
    about: 'About Platform',
    forWhom: 'Who It\'s For',
    opportunities: 'Opportunities',
    faq: 'FAQ'
  },
  hero: {
    badge: 'Human Intelligence Platform',
    title: 'Human Intelligence for the AI Era',
    subtitle: 'Earn remotely by helping train cutting-edge AI models and creating high-quality datasets for AGI',
    englishRequired: '🇬🇧 Fluent English proficiency required'
  },
  cta: {
    start: 'Get Started',
    getStarted: 'Join Now',
    learnMore: 'Learn More',
    startNow: 'Start Now'
  },
  about: {
    badge: 'About micro1',
    title: 'Next-Generation Data Platform',
    desc1: 'micro1 is a global platform connecting experts worldwide to create high-quality data essential for training advanced AI models and Artificial General Intelligence (AGI) systems.',
    desc2: 'We partner with leading AI labs and tech companies, providing access to vetted specialists who handle complex tasks including data labeling, model evaluation, content creation, and expert validation.',
    desc3: 'Every platform participant undergoes rigorous selection through our AI recruiter Zara, ensuring the highest quality of work and team professionalism.',
    englishNote: '⚠️ Important: All interviews and tasks on the platform are conducted in English. Fluent English proficiency is a mandatory requirement for work.',
    quote: 'Human expertise remains irreplaceable in the AI era. micro1 transforms human knowledge and skills into the foundation upon which the future of artificial intelligence is built.',
    quoteName: 'micro1 Team',
    quoteRole: 'Human Intelligence Platform'
  },
  forWhom: {
    title: 'Who Is This Platform For?',
    subtitle: 'micro1 welcomes specialists from various fields ready to work remotely and contribute to AI technology advancement',
    categories: [
      {
        title: 'Data Annotators and Labelers',
        desc: 'Specialists in labeling images, text, audio, and video for training computer vision, NLP, and multimodal systems.',
        icon: 'ri-image-edit-line'
      },
      {
        title: 'AI Model Evaluators',
        desc: 'Experts who test and assess the quality of language model responses, verifying accuracy, safety, and compliance with ethical standards.',
        icon: 'ri-star-line'
      },
      {
        title: 'Content Creators and Editors',
        desc: 'Copywriters, editors, and linguists creating quality textual content for training and fine-tuning language models in various languages.',
        icon: 'ri-edit-line'
      },
      {
        title: 'Programmers and Developers',
        desc: 'Specialists in code writing, solution verification, and creating synthetic data for training AI programming and code generation models.',
        icon: 'ri-code-s-slash-line'
      },
      {
        title: 'Domain Experts',
        desc: 'Professionals in medicine, law, science, finance, and other fields providing expert knowledge for specialized AI applications.',
        icon: 'ri-graduation-cap-line'
      },
      {
        title: 'Robotics Specialists',
        desc: 'Operators collecting real-world data on physical actions and movements for training next-generation robotic systems and humanoids.',
        icon: 'ri-robot-2-line'
      }
    ]
  },
  opportunities: {
    badge: 'Simple Process',
    title: 'Three Steps to Your First Earnings',
    steps: [
      {
        number: '01',
        title: 'Registration',
        desc: 'Follow the referral link and complete the form. Tell us about your skills and experience.'
      },
      {
        number: '02',
        title: 'Skills Assessment',
        desc: 'Complete testing through AI recruiter Zara. This may include tasks, interviews, or expert evaluation.'
      },
      {
        number: '03',
        title: 'Task Selection',
        desc: 'After approval, access the platform and choose tasks matching your skills and interests.'
      },
      {
        number: '04',
        title: 'Work and Payment',
        desc: 'Complete tasks at your convenience, receive payment for quality work, and develop expertise in the AI industry.'
      }
    ]
  },
  faq: {
    title: 'Frequently Asked Questions',
    subtitle: 'Answers to the most common questions about working on the platform',
    items: [
      {
        q: 'Is English language proficiency required for work?',
        a: 'Yes, fluent English proficiency is a mandatory requirement. All interviews with AI recruiter Zara, task instructions, team communication, and the work itself are conducted exclusively in English. Your proficiency level will be verified during the selection process.'
      },
      {
        q: 'How much can I earn on the micro1 platform?',
        a: 'Earnings depend on task type, your qualifications, and time invested. The platform does not guarantee fixed income, but many specialists receive competitive compensation for quality work. Rates vary based on project complexity and your expertise.'
      },
      {
        q: 'Do I need AI experience to start?',
        a: 'No, specific AI experience is not always required. Many tasks suit people without technical backgrounds. The main requirements are attentiveness, ability to follow instructions, and willingness to learn. Some specialized tasks may require expertise in specific areas.'
      },
      {
        q: 'How does the selection process work?',
        a: 'After registration, you interact with AI recruiter Zara, who assesses your skills through tests, assignments, or interviews (in English). The process takes from several days to several weeks depending on position complexity. Selection aims to find the best specialists for each task type.'
      },
      {
        q: 'Can I work from any country?',
        a: 'Yes, micro1 is a global platform open to specialists from different countries. However, some projects may have regional restrictions or language requirements (English is mandatory). Check details during registration.'
      },
      {
        q: 'What is the work schedule on the platform?',
        a: 'Work is entirely remote and flexible. You choose when and how much to work, depending on available tasks and your schedule. This can be either full-time employment or part-time work in your spare time.'
      },
      {
        q: 'How is compensation paid?',
        a: 'Payment is made according to specific project terms. International payment systems are typically used. Details on payment methods, frequency, and minimum amounts are clarified after platform approval.'
      }
    ]
  },
  finalCta: {
    title: 'Ready to Start?',
    subtitle: 'Join thousands of specialists worldwide helping create the future of AI',
    button: 'Register Now',
    social: 'Over 10,000 specialists already with us'
  },
  footer: {
    description: 'Human intelligence platform for training AI models and creating high-quality datasets for AGI.',
    contact: 'Contact',
    links: 'Navigation',
    company: 'Company',
    careers: 'Careers',
    research: 'Research'
  }
};
